import { Injectable } from '@angular/core';
import { KYMW2300Model } from '../kymw2300.model';
import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { ExecutePrintCompanyDataModel } from '../vo/execute-print-company-data.model';
import { PlessAlert } from '../../../../../app/shared/pless-alert/pless-alert.component';
import { PlessHttp } from '../../../../../app/shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../../app/commons/kymw00/pless-dialog-service-sub';
import { FileDownloadMultiService } from '../../../../../app/commons/kymw02/file-download-confirm/file-download-multi.service';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 印刷会社用データ出力画面　印刷会社用データの作成をするサービス
 *
 * @export ExecutePrintCompanyDataService
 * @class ExecutePrintCompanyDataService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class ExecutePrintCompanyDataService extends PlessJsonResponderSub<any> {

  /**
   * 処理に使用するModel
   *
   * @private
   * @type {KYMW2300Model}
   * @memberof ExecutePrintCompanyDataService
   */
  private model: KYMW2300Model;
  private vo: ExecutePrintCompanyDataModel;
  private filePathList: Array<any> = new Array<any>();
  private fileNameList: Array<any> = new Array<any>();

  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof ExecutePrintCompanyDataService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub,
    private fileDownloadMultiService: FileDownloadMultiService
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof ExecutePrintCompanyDataService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.orderCode,
        MediumType: this.vo.mediumType,
        CoopCode: this.vo.coopCode,
        ManuscriptsData: this.vo.manuscriptsData,
        BuyerDifferenceList: this.vo.buyerDifferenceList,
        EditDifferenceList: this.vo.editDifferenceList,
        TarProgressNum: this.vo.tarProgressNum,
        TarProgressName: this.vo.tarProgressName,
        ComProgressNum: this.vo.comProgressNum,
        ComProgressName: this.vo.comProgressName,
        OutputType: this.vo.outputType,
        OutputName: this.vo.outputName,
        PageIdList: this.vo.pageIdList,
        PageNumList: this.vo.pageNumList
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {ExecutePrintCompanyDataModel} vo
   * @param {Function} successFunc 成功時後続処理
   * @memberof ExecutePrintCompanyDataService
   */
  execute(model: KYMW2300Model, vo: ExecutePrintCompanyDataModel, successFunc: Function): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW23ExecutePrintCompanyData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof ExecutePrintCompanyDataService
   */
  success(data: any): void {
    if (data === null) {
      return;
    }
    this.successFunc(data);
    if (!PlessViewUtilsSub.isEmpty(data.EditFileUrl)) {
      this.filePathList.push(data.EditFileUrl);
      this.fileNameList.push('差分リスト(編集).zip');
    }

    if (!PlessViewUtilsSub.isEmpty(data.BuyerFileUrl)) {
      this.filePathList.push(data.BuyerFileUrl);
      this.fileNameList.push('差分リスト(バイヤー).zip');
    }

    if (this.filePathList.length > 0) {
      this.dialogService.openAlert('ファイルをダウンロードする準備ができました。\n続行しますか？', 'Q',
        [PlessAlert.No, PlessAlert.Yes],
        (closeDetail) => {
          if (closeDetail === PlessAlert.Yes) {
            this.download();
          }
        });
    }
  }

  /**
   * ダウンロード
   *
   * @private
   */
  private download(): void {
    this.fileDownloadMultiService.execute(this.filePathList[0], this.fileNameList[0], (res: any) => {
      // リストから処理済みとなった先頭の要素を削除
      this.filePathList.splice(0, 1);
      this.fileNameList.splice(0, 1);
      if (this.filePathList.length !== 0) {
        this.download();
      }
    });
  }
}
